import { Components, Theme } from '@mui/material/styles';

export default function MuiDialogTitle(theme: Theme): Components['MuiDialogTitle'] {
  return {
    defaultProps: {
      variant: 'lead',
    },
    styleOverrides: {
      root: {
        paddingTop: '32px',
        paddingLeft: '56px',
        paddingRight: '56px',
      },
    },
  };
}
